export const FADE_TRANSITION_PROPS = {
    timeout: 300,
    easing: "cubic-bezier(0.25, 0.1, 0.35, 1)",
} as const;
